<template>
  <div class="protocol login-protocol">
    <navigation>个人信息使用授权书</navigation> 
    <section class="content">
      <p class="text tab-2"><b>重要提示：</b></p>
      <p class="text tab-2"><b>您即将通过本登陆页面使用天美贷平台账户授权登录第三方站点或软件。</b></p>
      <p class="text tab-2"><b>为了保障您的合法权益，请您务必审慎阅读、充分理解本授权书各条款内容（特别是免除或者限制</b><b><u class="underline">重庆市崇天小额贷款有限公司（以下简称“被授权人”）</u>责任的条款和对您权利进行限制的条款等），并严格遵守本授权书。限制、免责条款或者其他涉及您重大权益的条款会以加粗等形式提示您重点注意。</b></p>
      <p class="text tab-2"><b>除非您已充分阅读、完全理解并接受本授权书所有条款，否则您无权使用相关服务。您点击“同意”或“下一步”，或您使用相关服务，或以其他任何明示或者默示方式表示接受本授权书的，均视为您已充分理解本授权书所有条款的含义及相应的法律后果并同意签署本授权书。本授权书即在您与被授权人之间产生法律效力。</b></p>
      <p class="text tab-2"> <b>一、授权内容</b></p>
      <p class="text tab-2"><b>1、本人（姓名： ；身份证号码： ）</b>同意并授权被授权人将本人的<b>天美贷平台账户所涉用户ID等相关信息和数据提供给第三方重庆领易付科技有限公司（以下简称“领易付”）并进一步授权领易付有权将本人的天美贷平台账户用户ID等相关信息和数据提供至其合作方（</b>上<b>海岫智科技有限公司），用于领易付及其合作方向本人提供</b><b>会员礼包等服务</b>。</p>
      <p class="text tab-2">2、本人同意并授权领易付及其合作方获取上述信息，且有权分析、使用本人上述信息，该等分析、使用可能会影响到给本人提供的会员礼包等服务。</p>
      <p class="text tab-2"><b>二、授权人承诺</b></p>
      <p class="text tab-2">1、本人明确知悉会员礼包等第三方服务由<b>领易付及其合作方</b>提供，且领易付及其合作方就以上服务及数据安全独立承担全部责任。<b>因该领易付及其合作方服务或其使用本人的信息产生的纠纷，或领易付及其合作方服务违反相关法律法规，或本人在使用领易付及其合作方服务过程中遭受的损失，本人将和领易付及其合作方自行协商解决</b>。</p>
      <p class="text tab-2">2、本人明确知悉网络欺诈往往会模仿、仿冒本登录页面的样式制作视觉感相似的页面，引诱用户输入账号和密码等信息。本人承诺不向非天美贷的站点或任何人士透露本人的天美贷账号、密码等相关信息。</p>
      <p class="text tab-2"><b>三、授权期限</b></p>
      <p class="text tab-2">本授权书授权期限为自本人作出本授权承诺之日起，至本人与被授权人、领易付及其合作方之间所有业务/服务终结之日止。<b>授权期限到期后，为了后续异议或纠纷处理，本人不可撤销地同意被授权人及第三方服务提供方仍可继续留存本人的个人信息</b>。</p>
      <p class="text tab-2">四、本授权书未尽事宜，以天美贷平台公示的<router-link class="link" to="/tmd/protocol/login">《天美贷平台用户注册协议》</router-link>、  <a class="link" @click="routerToProtocol('/tmd/protocol/privacy')" >《天美贷个人信息保护政策》</a>及相关规则为准；如有冲突的，以本授权书约定为准。</p>
      <p class="text tab-2"><b>五、授权人特别声明</b></p>
      <p class="text tab-2"><b>1、本授权书是本人向被授权人作出的单方承诺，效力具有独立性，不因其他协议的任何条款无效而无效。</b></p>
      <p class="text tab-2">2、本人已知悉并同意本授权书所载内容（特别是加粗字体内容）的含义及法律后果，自愿作出上述授权，本授权书系本人真实意思表示，本人同意承担由此带来的一切法律后果。</p>
      <p class="text tab-2">本人可通过面签授权（包括但不限于面签专门的授权文件、含有授权条款的合同或文件等）或信息网络方式（在包括但不限于通过被授权人及其关联方运营的天美贷或相关客户端、电话以及其他及时通信工具等数据电文方式进行签署或确认授权）给予被授权人授权。</p>
      <p class="text tab-2">特此授权！</p>
      <p class="text tab-2 text-right"> 授权人 (电子签名)</p>
      <p class="text tab-2 text-right"> 年 月 日</p>
    </section>
  </div>
</template>

<script>

export default {
  name: 'vipProtocol',
  created () {
    this.$bus.$emit('ready')
  }
}

</script>

<style lang="less">
@import "../../assets/less/mixin.less";

    .login-protocol {
        background-color: white;
        .link {
            color: #007AFF;
        }
        .text-right {
            text-align: right;
            padding-right: 60px;
        }
        .content {
            padding: 0 48px;
            .title {
                font-weight: bolder;
                color: #333333;
                font-size: 28px;
                text-indent: 40px;
                line-height: 44px;
                margin-top: 10px;
            }
            .text {
                color: #333333;
                font-size: 28px;
                text-indent: 40px;
                line-height: 44px;
            }
            .text:last-child {
                margin-bottom: 10px;
            }
            .underline {
                text-indent: 40px;
                font-weight: bold;
                text-decoration: underline;
            }
            .underline:last-child {
                margin-bottom: 10px;
            }
        }
    }
</style>
